// 餐饮项目路由详情
const linkChildren = [{
		label: '联系人管理',
		attrs: {},
		url: '/system/com/ContactManager',
		linkParent: {
			label: '企业管理',
			url: '/system/com',
		}
	},
	{
		label: '设施管理',
		attrs: {},
		url: '/system/com/DeviceManage',
		linkParent: {
			label: '企业管理',
			url: '/system/com',
		}
	},
	{
		label: '企业清单详情',
		attrs: {},
		url: '/enterprise/enterpriseList/detail',
		linkParent: {
			label: '监控分析',
			url: '/monitorAnalysis/caseDetail',
		}
	}, {
		label: '企业用电详情',
		attrs: {},
		url: '/enterprise/enterpriseList/detail/eledetail',
		linkParent: {
			label: '监控分析',
			url: '/monitorAnalysis/caseDetail',
		}
	}, {
		label: '异常申报',
		attrs: {},
		url: '/enterprise/enterpriseList/detail/declare',
		linkParent: {
			label: '监控分析',
			url: '/monitorAnalysis/caseDetail',
		}
	}, {
		label: '企业限产历史记录',
		attrs: {},
		url: '/enterprise/enterpriseList/history',
		linkParent: {
			label: '监控分析',
			url: '/monitorAnalysis/caseDetail',
		}
	}, {
		label: '用电详细信息',
		attrs: {},
		url: '/enterprise/workshopCase/eleDetail',
		linkParent: {
			label: '监控分析',
			url: '/monitorAnalysis/caseDetail',
		}
	}, {
		label: '用电详细信息',
		attrs: {},
		url: '/enterprise/enterpriseDevice/producePollutionDevice/detail',
		linkParent: {
			label: '监控分析',
			url: '/monitorAnalysis/caseDetail',
		}
	}, {
    label: '报表查看',
    attrs: {},
    url: '/dataAnalysis/checkReport',
    linkParent: {
      label: '统计报表',
      url: '/dataAnalysis/statisticReport',
    }
  }
]


export default linkChildren;



// WEBPACK FOOTER //
// ./src/layout/model/notInMenuRouteEn.js